import { LinkifyImageComponent } from './linkify-image/linkify-image.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { CullenFooterComponent } from './cullen-footer/cullen-footer.component';

import { ErrorComponent } from './error/error.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';

import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  imports: [CommonModule, RouterModule, QRCodeModule],

  declarations: [
    CullenFooterComponent,
    ErrorComponent,
    ComingSoonComponent,
    LinkifyImageComponent,
  ],
  exports: [CullenFooterComponent, LinkifyImageComponent],
})
export class UiModule {}
